import React from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../Component/Logo";
import LogoMini from "../Component/Logo-mini";

const Sidebar = ({ sidebar }) => {
  return (
    <>
      <div className={sidebar ? "sidebar-wrapper active" : "sidebar-wrapper"}>
        <div className="sidebar-header">
          <div className="d-flex justify-content-between">
            <div className="sidebar-logo">
              <Link to="/home">
                <Logo />
                <LogoMini />
              </Link>
            </div>
          </div>
        </div>
        <div className="sidebar-menu">
          <ul className="menu">
            <li className="sidebar-item">
              <NavLink to="/home" className="sidebar-link">
                <i className="bx bxs-home"></i>
                <span>Dashboard</span>
              </NavLink>
            </li>
            {/* <li className="sidebar-item">
              <NavLink to="/feedback" className='sidebar-link'>
                <i class='bx bx-message-rounded-dots'></i>
                <span>FeedBack</span>
              </NavLink>
            </li> */}
            <li className="sidebar-item">
              <NavLink to="/livetheme" className="sidebar-link">
                <i className="bx bxs-brush-alt"></i>
                <span>Live Theme</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/defaulttheme" className="sidebar-link">
                <i className="bx bxs-paint-roll"></i>
                <span>Default Theme</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/maincatgory" className="sidebar-link">
                <i className="bx bxs-category-alt"></i>
                <span>Main Categories</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/subcatgory" className="sidebar-link">
                <i className="bx bxs-collection"></i>
                <span>Sub Categories</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/keyboard/category" className="sidebar-link">
                <i className="bx bxs-layer"></i>
                <span>Keyboard Categories</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/keyboard/theme" className="sidebar-link">
                <i className="bx bxs-keyboard"></i>
                <span>Keyboard Theme</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/wallpaper" className="sidebar-link">
                <i className="bx bxs-image"></i>
                <span>Wallpaper</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/themeicon" className="sidebar-link">
                <i className="bx bxs-palette"></i>
                <span>Theme Icon</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/stories" className="sidebar-link">
                <i className="bx bxs-video-recording"></i>
                <span>Stories</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/widgets" className="sidebar-link">
                <i className="bx bxs-widget"></i>
                <span>Widgets</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/uploadata" className="sidebar-link">
                <i className="bx bxs-cloud-upload"></i>
                <span>Upload Data</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/dashboradtheme" className="sidebar-link">
                <i className="bx bxs-brush"></i>
                <span>Dashboard Theme</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/dashbordwidgets" className="sidebar-link">
                <i className="bx bxs-dashboard"></i>
                <span>Dashboard Widgets</span>
              </NavLink>
            </li>

            {/* ============================================================
                Theme Management (new, self-contained module).
                Uses only the new /theme-management APIs — never the
                legacy theme endpoints.
               ============================================================ */}
            <li className="sidebar-title" style={{ borderTop: "1px solid rgba(0,0,0,.08)", marginTop: 10, paddingTop: 10 }}>
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  opacity: 0.6,
                  paddingLeft: 12,
                }}
              >
                Theme Management
              </span>
            </li>
            <li className="sidebar-item">
              <NavLink to="/themes" className="sidebar-link">
                <i className="bx bxs-palette"></i>
                <span>Themes</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/theme-icons" className="sidebar-link">
                <i className="bx bxs-grid-alt"></i>
                <span>Theme Icons</span>
              </NavLink>
            </li>
            <li className="sidebar-item">
              <NavLink to="/theme-widgets" className="sidebar-link">
                <i className="bx bxs-widget"></i>
                <span>Theme Widgets</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
